import { tokens } from "../../theme";
import * as React from "react";
import {
  Box,
  Grid,
  useTheme,
} from "@mui/material";
import GreetingHeader from "../../components/GreetingHeader";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import isEmptyArray from "lodash/isEmpty";

import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  selectedItems,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  ERROR_WHILE_FETCHING_PAYOUT_DETAILS,
  FETCHING_PAYOUT_SUMMARY_PLEASE_WAIT,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  SOME_ERROR_OCCURRED,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  LOGIN_RESPONSE,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import {
  getPayoutDates,
  updateWitholdingTaxDetails,
  getPayoutDatesAuditActivityDetails,
  getPayoutDatesAuditActivityRowDetails,
} from "../../services/ApiService";

import * as CONSTANT from "../../constants/Constant";
import {
  incentivesColumnHeader,
  payoutdatesColumnHeader,
} from "../../components/ColumnHeader";
import CustomButton from "../../components/CustomButton";

import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import UserActivityPayoutDates from "../../components/UserActivityPayoutDates";
import AddNewCycleDialog from "./AddNewCycleDialog";
import dayjs from "dayjs";
import ShowAlertMessage from "../../components/ShowAlertMessage";

const PayoutDatesScreen = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const navigate = useNavigate();
  //const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [addNewCycleDialog, setAddNewCycleDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);

  const [payoutDatesAuditDetailsList, setPayoutDatesAuditDetailsList] =
    useState([]);
  const [payoutDates, setPayoutDates] = useState([]);

  const [
    deviceRembersementBundlePlanDates,
    setDeviceRembersementBundlePlanDates,
  ] = useState([]);
  const [
    deviceRembersementBroadbandPlanDates,
    setDeviceRembersementBroadbandPlanDates,
  ] = useState([]);
  
  const [
    mode,
    setEditMode,
  ] = useState("none");


  

  const [gridHeight, setGridHeight] = useState(1080); // Default height
  const [totalNoOfRows, setTotalNoOfRows] = useState(0); // Default height
 

  const [selectedDateRange, setSelectedDateRange] = useState(
    CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS
  );
  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  const [creditDebitAccountAuditActivity, setCreditDebitAccountAuditActivity] =
    useState("");
  const [editedBroadbandRowIndex, setEditedBroadbandRowIndex] = useState(null);
  const [saveButtonVisible, setSaveButtonVisibility] = useState(false);
  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [editAllowed, setEditAllowed] = useState(false);

  const [broadbandPlanEdited, setBroadbandPlanEdited] = useState(false);
  const [bundlePlanEdited, setBundlePlanEdited] = useState(false);
  const [incentivePlanEdited, setIncentivePlanEdited] = useState(false);

  //const [updatedRowId, setUpdateRowID] = useState([]);
// Initialize the state with an empty array
const [updatedRowIdAfterEdit, setUpdatedRowIdAfterEdit] = useState([]);

  //let updatedRowIdAfterEdit = []

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 100; // Height of header row
    const rowHeight = 100; // Height of each data row
    const rowCount = totalNoOfRows; // Total number of data rows
    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }
  
  useEffect(() => {
   
    updateButtonVisibility();
  }, []);

  useEffect(() => {
    getpayoutDatesData();

    getPayoutDatesActivityAuditDetails(activityCurrentPage, selectedDateRange);
  }, []);

  useEffect(() => {
    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, totalNoOfRows]);

  const updateButtonVisibility = () => {
    const sessionId = getFromLocalStorage(SESSION_ID);
    try {
      if (sessionId !== "") {
        const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);

        let adjustments = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Incentive") {
                adjustments = [...item.menuItem];
              }
            });

            adjustments.forEach((itemA, index) => {
              if (itemA.menuName === "Payout Dates") {
                const actionButtonList = [...itemA.actionButton];
                DebugLog(
                  "actionButtonList from sidebar    " +
                    JSON.stringify(actionButtonList)
                );


                actionButtonList.forEach((items, index) => {
                  if (items.buttonName === "DOWNLOAD") {
                    setDownlaodButton(true);
                  } else if (items.buttonName === "SAVE") {
                    setSaveButtonVisibility(true);
                    setEditMode("row")
                  } else if (items.buttonName === "EDIT") {
                    setEditAllowed(true);
                    setEditMode("row")
                  }
                });
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),

      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }
  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getPayoutDatesActivityAuditDetails(newPage, selectedDateRange);
  };
  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getPayoutDatesActivityAuditDetails(activityCurrentPage, selectedDateRange);
  };
  function getPayoutDatesActivityAuditDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        switch (passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_DATES_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getPayoutDatesAuditActivityDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.payoutDatesAuditDetails.content.map(
                  (row) => ({
                    ...row,
                    id: generateRandomId(),
                  })
                );

              setCreditDebitAccountAuditActivity(contentData);
              setActivityTotalNoOfPages(
                response.data.result.payoutDatesAuditDetails.totalPages
              );
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }
  async function getpayoutDatesData() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(FETCHING_PAYOUT_SUMMARY_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        // const id = "1";
        // const pageNumber = 1;
        // const pageSize = 10;

       // const payoutDetails = {
          // id: id,
          // pageNumber: pageNumber,
          // pageSize: pageSize,
       // };

        // initializeEncryption(
        //   payoutDetails,
        //   getFromLocalStorage(MESSAGE_KEY),
        //   ApiType.GET_PAYOUT_DATES_DETAILS
        // ).then((encryptedContentData) => {
          const payoutDatesRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            //contentData: encryptedContentData,
          };

          getPayoutDates(payoutDatesRequestData)
            .then((response) => {
              // ) {
              const incentiveArray = response.data.result.incentives;
              const incentive = incentiveArray.map((row) => ({
                ...row,
                id: generateRandomId(),
              }));
              setPayoutDates(incentive);
             
              const deviceReimbursementBundlePlanArray =
                response.data.result.dateRangeOfDeviceReimbursementBundlePlan;
              const deviceReimbursementBundlePlan =
                deviceReimbursementBundlePlanArray.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setDeviceRembersementBundlePlanDates(
                deviceReimbursementBundlePlan
              );

              const deviceReimbursementBroadbandPlanArray =
                response.data.result
                  .dateRangeOfDeviceReimbursementBroadbandPlan;
              const deviceReimbursementBroadbandPlan =
                deviceReimbursementBroadbandPlanArray.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setDeviceRembersementBroadbandPlanDates(
                deviceReimbursementBroadbandPlan
              );
              //}

              // Map through the original data and assign random IDs to rows
              //const rowsWithIds = response.data.result.payoutTypeDetails.map(row => ({ ...row, id: generateRandomId() }));

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
       // });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_PAYOUT_DETAILS + JSON.stringify(message)
      );
    }
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };
 
  const apiRef = useGridApiRef();

  const displayDetailedInfo = (data) => {
    setSelectedItem(data);
    addNewCycleDataApiRequest(data);
    //setAddNewCycleDialog(true);
  };

  // Function to check for overlaps
  function checkOverlaps(cycles) {
    for (let i = 1; i < cycles.length; i++) {
      if (cycles[i].start <= cycles[i - 1].end) {
        return false; // Overlap found
      }
    }
    return true; // No overlaps
  }

  function getUpdatedBroadBandDataAndSyncToServer(type) {
    if (type === 0 && broadbandPlanEdited === false) {
      showErrorAlert(
        "ALERT",
        "Please edit some values before save them on server!"
      );
    } else if (type === 1 && bundlePlanEdited === false) {
      showErrorAlert(
        "ALERT",
        "Please edit some values before save them on server!"
      );
    } else if (type === 2 && incentivePlanEdited === false) {
      showErrorAlert(
        "ALERT",
        "Please edit some values before save them on server!"
      );
    } else if(type == 2){
      createApiData(type)
    }
    
    else {
        let dataList = []
        if (type === 0) {
          dataList = [...deviceRembersementBroadbandPlanDates]
        }else  if (type === 1) {
          dataList = [...deviceRembersementBundlePlanDates]
        }
        // } else {
        //   dataList = [...payoutDates]
        // }

        let cycles = [];

        for (let i = 0; i < dataList.length; i++) {
          //const model = dataList[i];
          const startDate =  dataList[i].cycleStartDate
          const endDate =  dataList[i].cycleEndDate
          const start = Number(
            startDate
          );
          const end = Number(
            endDate
          );

          const cycleModel = {
            start: start,
            end: end
          };
          cycles.push(cycleModel);
        }

        // Sort cycles by start day
        const cyclesSorted = cycles.sort((a, b) => a.start - b.start);

        // Check if the cycles overlap
        if (checkOverlaps(cyclesSorted)) {
         // alert("No overlaps found.");
          createApiData(type)
        } else {
          showErrorAlert("Cycle Overlap detected", "Cycle START and END date should not overlap with the other cycle");
        }

       
       
    }
  };

  function createApiData(type){
   
    let finalList = [];
    let rembersementList = [];
   
    if (type === 0) {
    for (let i = 0; i < deviceRembersementBroadbandPlanDates.length; i++) {
      rembersementList.push(deviceRembersementBroadbandPlanDates[i]);
    }
  } else if (type === 1) {
    for (let i = 0; i < deviceRembersementBundlePlanDates.length; i++) {
      rembersementList.push(deviceRembersementBundlePlanDates[i]);
    }
  } else {
    for (let i = 0; i < payoutDates.length; i++) {
      rembersementList.push(payoutDates[i]);
    }
  }

  for (let j = 0; j < updatedRowIdAfterEdit.length; j++) {
      const editedRowId = updatedRowIdAfterEdit[j]
      for (let i = 0; i < rembersementList.length; i++) {
        const model = rembersementList[i];
        if(model.payoutId === editedRowId){
          let dataModel = {
            payoutId: model.payoutId,
            cycleStartDate: model.cycleStartDate!==null?model.cycleStartDate:"",
            cycleEndDate: model.cycleEndDate!==null?model.cycleEndDate:"",
            reportDay: model.reportDay,
            cutOffDay: model.cutOffDay,
            payoutDay: model.payoutDay,
            expiryStartDate: model.expiryStartDate,
            expiryEndDate: model.expiryEndDate,
            commissionDescription: model.description,
          };
      
          finalList.push(dataModel);
        }
       
      }
  }

 

  updateDataToServer(finalList, type);

  }

  function updateDataToServer(data, type) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);
        let requestObject = {
          updatePayoutDatesDetailsList: data,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.UPDATE_PAYOUT_DATES_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          updateWitholdingTaxDetails(requestData)
            .then((response) => {
              if(response  && response.data.responseCode === "0"){
                setUpdatedRowIdAfterEdit([])
                let successMsgType = "";
                if (type === 0) {
                  successMsgType =
                    "Device Broadband Reimbursement updated successfuly";
                  setBroadbandPlanEdited(false);
                } else if (type === 1) {
                  successMsgType =
                    "Device Bundle Reimbursement updated successfuly";
                  setBundlePlanEdited(false);
                } else {
                  successMsgType = "Incentives updated successfuly";
                  setIncentivePlanEdited(false);
                }
                showErrorAlert("SUCCESS", successMsgType);
  
                getPayoutDatesActivityAuditDetails(
                  activityCurrentPage,
                  selectedDateRange
                );
              }
             

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              }  else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const handleProcessDeviceRembersementBroadbandPlanRowUpdate = (
    newRow,
    oldRow
  ) => {
    try{
      var expiryStartDateString = newRow.expiryStartDate;
      var expiryEndDateString = newRow.expiryEndDate;
  
     
    const today= dayjs().format('DD/MM/YYYY');
    const expiryStartDate = dayjs(expiryStartDateString)//.format('DD/MM/YYYY');
    const expiryEndDate = dayjs(expiryEndDateString)//.format('DD/MM/YYYY');

    var reportDay = Number(newRow.reportDay);
    var cycleStartDate = Number(newRow.cycleStartDate);
    var cycleEndDate = Number(newRow.cycleEndDate);

    var cutoffDay = Number(newRow.cutOffDay);
    var payoutByDay = Number(newRow.payoutDay);

    var expiryStartDateString = newRow.expiryStartDate;
    var expiryEndDateString = newRow.expiryEndDate;

   
    

    if (newRow.description==="") {
      showErrorAlert(
        "Error",
        "Please enter some text for cycle Name!"
      );
      return oldRow;
    }
   else if (reportDay > cycleStartDate && reportDay < cycleEndDate) {
      showErrorAlert(
        "Error",
        "REPORT date should not be in between START and END dates!"
      );
      return oldRow;
    } else if (cycleStartDate > cycleEndDate) {
      showErrorAlert(
        "Error",
        "START date should always be less than the END date!"
      );
      return oldRow;
    } else if (cycleEndDate < cycleStartDate) {
      showErrorAlert(
        "Error",
        "END date should always be greater than the START date!"
      );
      return oldRow;

    // } else if (payoutByDay < cutoffDay) {
    //   showErrorAlert(
    //     "Error",
    //     "PAYOUT BY date should be greater than the CUT OFF date!"
    //   );
    //   return oldRow;
    
    } else if (cutoffDay > payoutByDay) {
      showErrorAlert(
        "Error",
        "CUT OFF date should be less than the PAYOUT BY date!"
      );
      return oldRow;
   
    } else if (cutoffDay !== (payoutByDay - 2)) {
      showErrorAlert(
        "Error",
        "CUT OFF date should be two days less than PAYOUT BY date!"
      );
      return oldRow;

    // } else if (expiryStartDate.isBefore(today)) {
    //   showErrorAlert(
    //     "Error",
    //     "BEGIN date should not be less than the Today's date!"
    //   );
    //   return oldRow;
   
    // } else if (expiryStartDate.isAfter(today)) {
    //   showErrorAlert(
    //     "Error",
    //     "BEGIN date should not be greater than the Today's date!"
    //   );
    //   return oldRow;
   
    }
    
    else if (cutoffDay < reportDay) {
      showErrorAlert(
        "Error",
        "CUT OFF date should be greater than REPORT date!"
      );
      return oldRow;

    }
    else if (cutoffDay >= cycleStartDate && cutoffDay <= cycleEndDate) {
       showErrorAlert(
         "Error",
         "CUT OFF date should not be in between START and END dates!"
       );
       return oldRow;
   
    }
  //   else if (payoutByDay >= cycleStartDate && payoutByDay <= cycleEndDate) {
  //     showErrorAlert(
  //       "Error",
  //       "PAYOUT BY date should not be in between START and END dates!"
  //     );
  //     return oldRow;
  
  //  }
    else if (expiryStartDateString === expiryEndDateString) {
      showErrorAlert("Error", "BEGIN date same as EXPIRY date is not allowed!");
      return oldRow;
    } else if (expiryStartDate.isAfter(expiryEndDate)) {
      showErrorAlert(
        "Error",
        "BEGIN date should always be less than the EXPIRY date!"
      );
      return oldRow;
    } else if (!expiryEndDate.isAfter(expiryStartDate)) {
      showErrorAlert(
        "Error",
        "EXPIRY date should always be greater than the BEGIN date!"
      );
      return oldRow;
    } else {
      setBroadbandPlanEdited(true);

      const updatedRows = deviceRembersementBroadbandPlanDates.map((row) =>
        row.payoutId === oldRow.payoutId ? newRow : row
      );

      setUpdatedRowIdAfterEdit((prevArray) => {
        if (!prevArray.includes(newRow.payoutId)) {
        const newArray = [...prevArray, newRow.payoutId];
        // Actions to perform immediately after the state update
        return newArray;
        }
        else {
          return prevArray
        }
      });
      
      setDeviceRembersementBroadbandPlanDates(updatedRows);
      DebugLog(
        "updatedRows device broadband plan >>>>" + JSON.stringify(updatedRows)
      );
      return newRow;
    }

  }catch(e){
    DebugLog(e+"")
    return oldRow;
  }
  };

  const handleProcessDeviceRembersementBundlePlanRowUpdate = (
    newRow,
    oldRow
  ) => {
    var reportDay = Number(newRow.reportDay);
    var cycleStartDate = Number(newRow.cycleStartDate);
    var cycleEndDate = Number(newRow.cycleEndDate);

    var cutoffDay = Number(newRow.cutOffDay);
    var payoutByDay = Number(newRow.payoutDay);

    var expiryStartDateString = newRow.expiryStartDate;
    var expiryEndDateString = newRow.expiryEndDate;

    const expiryStartDate = dayjs(expiryStartDateString);
    const expiryEndDate = dayjs(expiryEndDateString);

    if (newRow.description==="") {
      showErrorAlert(
        "Error",
        "Please enter some text for cycle Name!"
      );
      return oldRow;
    }
   else if (reportDay > cycleStartDate && reportDay < cycleEndDate) {
      showErrorAlert(
        "Error",
        "REPORT date should not be in between START and END dates!"
      );
      return oldRow;
    } else if (cycleStartDate > cycleEndDate) {
      showErrorAlert(
        "Error",
        "START date should always be less than the END date!"
      );
      return oldRow;
    } else if (cycleEndDate < cycleStartDate) {
      showErrorAlert(
        "Error",
        "END date should always be greater than the START date!"
      );
      return oldRow;

    } else if (cutoffDay > payoutByDay) {
      showErrorAlert(
        "Error",
        "CUT OFF date should be less than the PAYOUT BY date!"
      );
      return oldRow;
   
    } else if (cutoffDay !== (payoutByDay - 2)) {
      showErrorAlert(
        "Error",
        "CUT OFF date should be two days less than PAYOUT BY date!"
      );
      return oldRow;

    } else if (cutoffDay <= reportDay) {
      showErrorAlert(
        "Error",
        "CUT OFF date should be greater then the REPORT date!"
      );
      return oldRow;
      
    } else if (cutoffDay >= cycleStartDate && cutoffDay <= cycleEndDate) {
      showErrorAlert(
        "Error",
        "CUT OFF date should not be in between START and END dates!"
      );
      return oldRow;
  
   }
  //  else if (payoutByDay >= cycleStartDate && payoutByDay <= cycleEndDate) {
  //    showErrorAlert(
  //      "Error",
  //      "PAYOUT BY date should not be in between START and END dates!"
  //    );
  //    return oldRow;
 
  // }
    
    else if (expiryStartDateString === expiryEndDateString) {
      showErrorAlert("Error", "BEGIN date same as EXPIRY date is not allowed!");
      return oldRow;
    } else if (expiryStartDate.isAfter(expiryEndDate)) {
      showErrorAlert(
        "Error",
        "BEGIN date should always be less than the EXPIRY date!"
      );
      return oldRow;
    } else if (!expiryEndDate.isAfter(expiryStartDate)) {
      showErrorAlert(
        "Error",
        "EXPIRY date should always be greater than the BEGIN date!"
      );
      return oldRow;
    } else {
      setBundlePlanEdited(true);
      const updatedRows = deviceRembersementBundlePlanDates.map((row) =>
        row.payoutId === oldRow.payoutId ? newRow : row
      );

      setUpdatedRowIdAfterEdit((prevArray) => {
        if (!prevArray.includes(newRow.payoutId)) {
        const newArray = [...prevArray, newRow.payoutId];
        // Actions to perform immediately after the state update
        return newArray;
        }
        else {
          return prevArray
        }
      });
      setDeviceRembersementBundlePlanDates(updatedRows);
      DebugLog(
        "updatedRows device bundle plan >>>>" + JSON.stringify(updatedRows)
      );
      return newRow;
    }
  };

  const handleProcessIncentiveRowUpdate = (newRow, oldRow) => {
    
    var reportDay = Number(newRow.reportDay);
    var cutoffDay = Number(newRow.cutOffDay);
    var payoutByDay = Number(newRow.payoutDay);

    var expiryStartDateString = newRow.expiryStartDate;
    var expiryEndDateString = newRow.expiryEndDate;

    const expiryStartDate = dayjs(expiryStartDateString);
    const expiryEndDate = dayjs(expiryEndDateString);
    
    if (newRow.description==="") {
      showErrorAlert(
        "Error",
        "Please enter some text for cycle Name!"
      );
      return oldRow;
  //   }
  //  else if (reportDay > cutoffDay) {
  //     showErrorAlert("Error", "REPORT date should be less than CUT OFF date!");
  //     return oldRow;
   
  } else if (cutoffDay > payoutByDay) {
    showErrorAlert(
      "Error",
      "CUT OFF date should be less than the PAYOUT BY date!"
    );
    return oldRow;
 
  } else if (cutoffDay !== (payoutByDay - 2)) {
    showErrorAlert(
      "Error",
      "CUT OFF date should be two days less than PAYOUT BY date!"
    );
    return oldRow;

  } else if (cutoffDay <= reportDay) {
    showErrorAlert(
      "Error",
      "CUT OFF date should be greater then the REPORT date!"
    );
    return oldRow;
    } else if (expiryStartDate.isAfter(expiryEndDate)) {
      showErrorAlert(
        "Error",
        "BEGIN date should always be less than EXPIRY date!"
      );
      return oldRow;
    } else if (!expiryEndDate.isAfter(expiryStartDate)) {
      showErrorAlert(
        "Error",
        "EXPIRY date should always be greater than BEGIN date!"
      );
      return oldRow;
    } else {
      setIncentivePlanEdited(true);

      const updatedRows = payoutDates.map((row) =>
        row.payoutId === oldRow.payoutId ? newRow : row
      );
      setUpdatedRowIdAfterEdit((prevArray) => {
        if (!prevArray.includes(newRow.payoutId)) {
        const newArray = [...prevArray, newRow.payoutId];
        // Actions to perform immediately after the state update
        return newArray;
        }
        else {
          return prevArray
        }
      });
    
      setPayoutDates(updatedRows);
      DebugLog(
        "updatedRows Incentive Dates plan >>>>" + JSON.stringify(updatedRows)
      );
      return newRow;
    }
  };

  const handleProcessRowUpdateError = (error) => {
  };

  const handleBroadbandReimbursementCellEditCommit = (params) => {
    // Find the index of the edited row
    const rowIndex = deviceRembersementBroadbandPlanDates.findIndex(
      (row) => row.id === params.id
    );
    setEditedBroadbandRowIndex(rowIndex);

  };

  const handleCloseDialog = () => {
    setAddNewCycleDialog(false);
  };

  function addNewCycleDataApiRequest(data) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          payoutDateAuditId: data.payoutDateIds + "",
          //payoutDateAuditId: "98",
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_DATES_ACTIVITY_ROW_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getPayoutDatesAuditActivityRowDetails(requestData)
            .then((response) => {
              setLoading(false);
              setPayoutDatesAuditDetailsList(response.data.result);
              setAddNewCycleDialog(true);

              // setAuditActivityRowData()
              // showErrorAlert(
              //   "UPDATED",
              //   "Freeze account details updated successfully."
              // );
              // getFreezeAccountDetailsData(
              //   paginationModel.page,
              //   paginationModel.pageSize
              // );
              // getFreezeAccountActivityDetails(activityCurrentPage, selectedDateRange);

              // getFreezedAccountCountDetails();
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />

       <ShowAlertMessage
          status={getDialogStatus}
          title={title}
          content={content}
        />


        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            width: "auto",
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container>
            <Grid item>
              <GreetingHeader name={"Payout Dates"}></GreetingHeader>
            </Grid>
          </Grid>
          {/* Greetings Header */}

          {/* Action Buttons */}
          {/* {payoutDates.length > 0 ? (
            <Grid item mt={0} mr={10} justifyContent={"flex-start"} pb={0}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
           

                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Tick.svg" width={22} />
                  }
                  btnTxt={"ADD CYCLE"}
                  onClick={displayDetailedInfo}
                ></CustomButton>
              </Stack>
            </Grid>
          ) : (
            ""
          )} */}
          {/* Action Buttons */}

          {/* Validations Section */}
          <Grid
            container
            mt={3}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            {/* New Payout Dates Code */}

            {/* Section */}
            <Grid
              container
              xs={12}
              direction={"column"}
              mb={3}
              sx={{
                background: colors.grey[900],
                border: "1px solid" + colors.grey[600],
                borderRadius: "8px",
              }}
            >
              {/* Header */}
              <Grid container p={3} alignItems={"center"}>
                <Grid
                  item
                  xs={8}
                  sm={9}
                  md={10}
                  sx={{ fontSize: "18px", fontWeight: "500" }}
                >
                  1. &nbsp;Device Reimbursement Broadband Plan
                </Grid>
                {saveButtonVisible === true ? (
                  <Grid item xs={4} sm={3} md={2} justifyContent={"flex-end"}>
                    <CustomButton
                      width={"100%"}
                      btnBG={colors.grey[900]}
                      btnColor={colors.grey[100]}
                      btnStartIcon={
                        <img
                          src="../../assets/common/edit_icon.png"
                          width={22}
                        />
                      }
                      btnTxt={"SAVE"}
                      onClick={() => getUpdatedBroadBandDataAndSyncToServer(0)}
                    ></CustomButton>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              {/* Header */}

              {/* Device Rembursement Table */}

              <Box
                sx={{
                  width: "100%",
                  "& .actions": {
                    color: "text.secondary",
                  },
                  "& .textPrimary": {
                    color: "text.primary",
                  },
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace:"break-spaces"
                  },
                }}
              >
                <DataGrid
                  // ref={dataGridRef}
                  editMode={mode}
                  rows={deviceRembersementBroadbandPlanDates}
                  autoHeight
                  processRowUpdate={
                    handleProcessDeviceRembersementBroadbandPlanRowUpdate
                  }
                  onCellEditCommit={handleBroadbandReimbursementCellEditCommit}
                  onProcessRowUpdateError={handleProcessRowUpdateError}
                  columns={payoutdatesColumnHeader}
                  experimentalFeatures={{ newEditingApi: true }}
                  ref={apiRef}
                />
              </Box>

              {/* Table */}
            </Grid>
            {/* Section */}

            {/* Section */}
            <Grid
              container
              xs={12}
              direction={"column"}
              mb={3}
              sx={{
                background: colors.grey[900],
                border: "1px solid" + colors.grey[600],
                borderRadius: "8px",
              }}
            >
              {/* Header */}
              <Grid container p={3} alignItems={"center"}>
                <Grid
                  item
                  xs={8}
                  sm={9}
                  md={10}
                  sx={{ fontSize: "18px", fontWeight: "500" }}
                >
                  2. &nbsp;Device Reimbursement Bundle Plan
                </Grid>
                {saveButtonVisible === true ? (
                  <Grid item xs={4} sm={3} md={2} justifyContent={"flex-end"}>
                    <CustomButton
                      width={"100%"}
                      btnBG={colors.grey[900]}
                      btnColor={colors.grey[100]}
                      btnStartIcon={
                        <img
                          src="../../assets/common/edit_icon.png"
                          width={22}
                        />
                      }
                      btnTxt={"SAVE"}
                      onClick={() => getUpdatedBroadBandDataAndSyncToServer(1)}
                    ></CustomButton>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              {/* Header */}

              {/*Device broadband reimbursement Table */}

              {/* <FullFeaturedCrudGrid deviceReimbursementBroadbandPlan={deviceRembersementBundlePlanDates}/> */}
              <Box
                sx={{
                  width: "100%",
                  "& .actions": {
                    color: "text.secondary",
                  },
                  "& .textPrimary": {
                    color: "text.primary",
                  },
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                }}
              >
                <DataGrid
                  editMode={mode}
                  autoHeight
                  rows={deviceRembersementBundlePlanDates}
                  columns={payoutdatesColumnHeader}
                  experimentalFeatures={{ newEditingApi: true }}
                  processRowUpdate={
                    handleProcessDeviceRembersementBundlePlanRowUpdate
                  }
                  onCellEditCommit={handleBroadbandReimbursementCellEditCommit}
                  onProcessRowUpdateError={handleProcessRowUpdateError}
                />
              </Box>
              {/* Table */}
            </Grid>
            {/* Section */}

            {/* Section */}
            <Grid
              container
              xs={12}
              direction={"column"}
              mb={3}
              sx={{
                background: colors.grey[900],
                border: "1px solid" + colors.grey[600],
                borderRadius: "8px",
              }}
            >
              {/* Header */}
              <Grid container p={3} alignItems={"center"}>
                <Grid
                  item
                  xs={8}
                  sm={9}
                  md={10}
                  sx={{ fontSize: "18px", fontWeight: "500" }}
                >
                  3. &nbsp;Incentives
                </Grid>
                {saveButtonVisible === true ? (
                  <Grid item xs={4} sm={3} md={2} justifyContent={"flex-end"}>
                    <CustomButton
                      width={"100%"}
                      btnBG={colors.grey[900]}
                      btnColor={colors.grey[100]}
                      btnStartIcon={
                        <img
                          src="../../assets/common/edit_icon.png"
                          width={22}
                        />
                      }
                      btnTxt={"SAVE"}
                      onClick={() => getUpdatedBroadBandDataAndSyncToServer(2)}
                    ></CustomButton>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              {/* Header */}

              {/*Device broadband reimbursement Table */}

              {/* <FullFeaturedCrudGrid deviceReimbursementBroadbandPlan={deviceRembersementBundlePlanDates}/> */}
              <Box
                sx={{
                  width: "100%",
                  "& .actions": {
                    color: "text.secondary",
                  },
                  "& .textPrimary": {
                    color: "text.primary",
                  },
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                }}
              >
                <DataGrid
                editMode={mode}
                  rows={payoutDates}
                  autoHeight
                  columns={incentivesColumnHeader}
                  experimentalFeatures={{ newEditingApi: true }}
                  processRowUpdate={handleProcessIncentiveRowUpdate}
                  onCellEditCommit={handleBroadbandReimbursementCellEditCommit}
                  onProcessRowUpdateError={handleProcessRowUpdateError}
                />
              </Box>
              {/* Table */}
            </Grid>
            {/* Section */}
          </Grid>
          {/* Validations Section */}

          {/* activity list */}
          {/* <Grid container> */}

            <UserActivityPayoutDates
              type={"PayoutDates"}
              data={creditDebitAccountAuditActivity}
              ondateRangeChange={handleDateRangeChange}
              totalNoOfPages={activityTotalNoOfPages}
              onPageChange={handleActivityPageChange}
              onItemClicked={displayDetailedInfo}
            />
          {/* </Grid> */}
        
          {/* <Grid container> */}
            <AddNewCycleDialog
              open={addNewCycleDialog}
              onClose={handleCloseDialog}
              onDialogButtonClick={addNewCycleDataApiRequest}
              onDialogRemoveButtonClick={handleCloseDialog}
              data={payoutDatesAuditDetailsList}
              selectedRowData={selectedItem}
            />
            {/* </Grid> */}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};

export default PayoutDatesScreen;
